export const GET_LINKFEATURE_API = () =>
  `https://app.rankspro.io/api/user/linkfeature/`;

export const POST_LINKFEATURE_API = () =>
  `https://app.rankspro.io/api/user/userlink/`;

export const GET_SAVELINKFEATURE_API = (email) =>
  `https://app.rankspro.io/api/user/userlinkget/?email=${email}`;

export const POST_STRIPECHECKOUT = () =>
  `https://app.rankspro.io/api/user/stripecheckout/`;
